import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { FaEye, FaEyeSlash, FaSpinner, FaSyncAlt, FaShieldAlt } from 'react-icons/fa';
import toast from 'react-hot-toast';
import { TOAST_SUCCESS_IDS, TOAST_ERROR_IDS } from '../../../../interaces/toast.ids.interface';
import { renapoSystemConfigurationsApi } from '../../api/renapoSystemConfigurations.api';
import { useAuth } from '../../../../context/AuthContext';
import { ENUM_PERMISSIONS } from '../../../../interaces/enums/enums.interface';
import { useRenapo } from '../../../interoperability/hooks/useRenapo';
import styles from "../../styles/styles.module.css"
function ModalRenapoSystemConfigurations() {
  const { hasPrivilege } = useAuth();

  const {
    testConfigActive,
    testingConfigActive,
    testThisConfig,
    testingThisConfig,
    isOkThisConfig,
    onChangeIsOkThisConfig,
  } = useRenapo();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [testOk, setTestOk] = useState(null); // null | true | false
  const [currentConfig, setCurrentConfig] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
  } = useForm();

  const loadConfig = async () => {
    try {
      const data = await renapoSystemConfigurationsApi.getActive();
      if (data) {
        setCurrentConfig(data);
        reset({
          urlEndpoint: data.urlEndpoint,
          username: data.username,
        });
      }
    } catch {}
  };

  useEffect(() => {
    loadConfig();
  }, []);

  useEffect(() => {
    if (isDirty) setTestOk(null);
  }, [isDirty]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await renapoSystemConfigurationsApi.update(data);
      toast.success(
        TOAST_SUCCESS_IDS?.RECORD_SAVED_SUCCESSFULLY || 'Configuración guardada correctamente',
        { id: TOAST_SUCCESS_IDS?.RECORD_SAVED_SUCCESSFULLY }
      );
      setTestOk(null);
      loadConfig();
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="card-base ">
      <div className={styles.mainDivModal}>
        <FaShieldAlt className="text-primary" size={20} />
        <h2 className={styles.descriptionModal}>Configuración RENAPO</h2>
      </div>
      <p className="modal-description">
        Credenciales del Web Service SOAP de RENAPO para la consulta de datos personales por CURP.
      </p>
      {currentConfig && (
        <div className={styles.currentConfig}>
          <span className={styles.activeConection}>Endpoint activo:</span>{' '}
          <span className={styles.urlActiveConection}>{currentConfig.urlEndpoint}</span>
        </div>
      )}
      {/* boton ppara probar la condiguracion guardada y activa actualmente */}
      {hasPrivilege(ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_TYPE_CREATE) && currentConfig && (
        <div className={styles.renapoDivTestConfigActive}>
          <button
            type="button"
            onClick={() => testConfigActive()}
            disabled={testingConfigActive}
            className={styles.renapoButtonTestConfigActive}
          >
            {testingConfigActive ? <FaSpinner className={styles.iconFaSpinner} /> : <FaSyncAlt />}
            {testingConfigActive ? 'Verificando...' : 'Probar configuración activa'}
          </button>
        </div>
      )}

      <form className="form-modal" onSubmit={handleSubmit(onSubmit)}>
        <div className="div-flex">
          <div className="div-atribute-form-w-full">
            <label className="label-base">
              URL del Endpoint SOAP <p className="modal-input-required">*</p>
            </label>
            <input
              type="text"
              maxLength={255}
              {...register('urlEndpoint', {
                required: 'La url es requerida',
                onChange: () => {
                  onChangeIsOkThisConfig();
                },
              })}
              placeholder="http://201.144.17.230:8084/wsCURP/wsConsultaSOAP"
              className="input-atribute-form"
            />
            {errors.urlEndpoint && (
              <span className="error-text">{errors.urlEndpoint.message}</span>
            )}
          </div>
        </div>

        <div className="div-flex">
          <div className="div-atribute-form-w-full">
            <label className="label-base">
              Usuario <p className="modal-input-required">*</p>
            </label>
            <input
              type="text"
              maxLength={100}
              {...register('username', {
                required: 'El usuario es requerido',
                onChange: () => {
                  onChangeIsOkThisConfig();
                },
              })}
              placeholder="Usuario de autenticación SOAP"
              className="input-atribute-form"
            />
            {errors.username && <span className="error-text">{errors.username.message}</span>}
          </div>

          <div className="div-atribute-form-w-full">
            <label className="label-base">
              Contraseña <p className="modal-input-required">*</p>
            </label>
            <div className="div-password-relative">
              <input
                type={showPassword ? 'text' : 'password'}
                maxLength={100}
                {...register('password', {
                  required: 'La contraseña es requerida',
                  onChange: () => {
                    onChangeIsOkThisConfig();
                  },
                })}
                placeholder="Contraseña de autenticación SOAP"
                className="input-atribute-form"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className={styles.btnPassword}
              >
                {showPassword ? (
                  <FaEyeSlash className={styles.iconFaEyeSlash} size={17} />
                ) : (
                  <FaEye size={17} />
                )}
              </button>
            </div>
            {errors.password && <span className="error-text">{errors.password.message}</span>}
          </div>
        </div>

        {testOk === true && (
          <div className={styles.testOk}>
            Conexión con RENAPO verificada exitosamente.
          </div>
        )}
        {testOk === false && (
          <div className={styles.testFailed}>
            No se pudo conectar con RENAPO. Revisa los datos e intenta de nuevo.
          </div>
        )}

        {hasPrivilege(ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_TYPE_CREATE) && (
          <div className="div-footer-form-actions">
            <button
              type="button"
              onClick={handleSubmit(testThisConfig)}
              disabled={testingThisConfig}
              className={styles.buttonFooterTest}
            >
              {testingThisConfig ? <FaSpinner className={styles.iconFaSpinner} /> : <FaSyncAlt />}
              {testingThisConfig ? 'Verificando...' : 'Probar conexión'}
            </button>
            <button type="submit" disabled={!isOkThisConfig} className="button-footer-form-confirm">
              {loading ? 'Guardando...' : 'Guardar configuración'}
            </button>
          </div>
        )}
      </form>
    </div>
  );
}

export default ModalRenapoSystemConfigurations;
